import styled from '@emotion/styled';
import { Css } from '@/ui';

export const PaginationWrap = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	margin-top: ${Css.pxToRemFromTheme(24)};
`;
